import React, { cloneElement, Component } from 'react';
import styled, { css, cx } from 'react-emotion';

import logoPython from './assets/python.png';
import logoScala from './assets/scala.png';
import logoNode from './assets/nodejs.png';
import logoEcmaJs from './assets/ecmajs.png';
import logoReact from './assets/react.png';
import logoHtml5 from './assets/html5.png';
import logoCss3 from './assets/css3.png';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 38px;
`;

const Image = styled.img`
  transition: all 0.4s ease-in-out;
  display: block;
  filter: grayscale(100%);
  opacity: 0;
  transform: translateY(15%);
`;

const loadedImage = css`
  opacity: 1;
  transform: translateY(0px);
  -webkit-filter: grayscale(100%);
`;

class StackLogos extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isMounted: false,
      registry: [],
    };
  }

  componentDidMount() {
    this.setState({
      registry: this.buildRegistry(),
      isMounted: true,
    });
  }

  handleLoad = key => {
    const { registry } = this.state;
    const loadedItem = registry[key];
    loadedItem.isLoaded = true;
    loadedItem.node = cloneElement(loadedItem.node, {
      className: cx(loadedItem.node.className, loadedImage),
    });
    this.setState({ registry });
  };

  images = [
    <Image src={logoPython} alt="Python" width="38" height="38" />,
    <Image src={logoScala} alt="Scala" width="21" height="38" />,
    <Image src={logoNode} alt="NodeJS" width="34" height="38" />,
    <Image src={logoEcmaJs} alt="JS" width="38" height="38" />,
    <Image src={logoReact} alt="React" width="43" height="38" />,
    <Image src={logoHtml5} alt="HTML5" width="27" height="38" />,
    <Image src={logoCss3} alt="CSS3" width="27" height="38" />,
  ];

  buildRegistry = () =>
    this.images.map((imageElement, idx) => ({
      node: cloneElement(imageElement, {
        key: idx,
        onLoad: () => this.handleLoad(idx),
      }),
      isLoaded: false,
      hasError: false,
    }));

  render() {
    return <Wrapper>{this.state.isMounted && this.state.registry.map(item => item.node)}</Wrapper>;
  }
}

export default StackLogos;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/StackLogos/StackLogos.jsx